import React, { useEffect, useState } from 'react'
import { ActionIcon, Group, Pill, Popover, Stack, Text, Textarea, TextInput } from '@mantine/core'
import { FilterLabels, VectorSearchFilters } from '../../../../../lib/types'
import { IconCheck, IconX } from '@tabler/icons-react'

type TextInputFilterProps = {
  textValue: string
  term: 'jobTitle' | 'jobDescription'
  selectedFilters: VectorSearchFilters
  placeholder: string
  textarea?: boolean
  w?: string | number
  onAdd: (term: string, value: string) => void
  onRemove: (term: string, value: string) => void
}

export const TextInputFilter = ({ textValue, selectedFilters, onAdd, onRemove, placeholder, term, textarea, w=600 }: TextInputFilterProps) => {
  const [value, setValue] = useState(textValue)
  const [popoverOpen, setPopoverOpen] = useState(false)

  useEffect(() => {
    setValue(textValue)
  }, [textValue])

  const handleApply = () => {
      onAdd(term, value)
      setPopoverOpen(false)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLParagraphElement | HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      handleApply()
    }
  }

  const handleClose = () => {
    setPopoverOpen(false)
    setTimeout(() => {
      setValue(textValue)
    }, 500)
  }

  return (
      <>
          <Popover
            width={w}
            position="bottom-start"
            withArrow
            opened={popoverOpen}
            onChange={open => !!open ? setPopoverOpen(true) : handleClose()}
            arrowSize={14}
            offset={0}
            trapFocus
          >
            <Popover.Target>
              <Text
                size='sm'
                mx={!!selectedFilters[term] && !!selectedFilters[term]?.length ? 0 : 30}
                style={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 600 }}
                onClick={() => setPopoverOpen(true)}
              >
                {FilterLabels[term]}:
              </Text>
            </Popover.Target>
            <Popover.Dropdown>
              <Stack>
                { !textarea ?
                  <TextInput 
                    label={FilterLabels[term]}
                    placeholder={placeholder}
                    defaultValue={textValue}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                  /> :
                  <Textarea
                    rows={4}
                    label={FilterLabels[term]}
                    placeholder={placeholder}
                    defaultValue={textValue}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                }
                <Group justify='flex-end'>
                  <ActionIcon onClick={handleClose} color='red'>
                    <IconX style={{ width: '90%', height: '90%' }} stroke={2} />
                  </ActionIcon>
                  <ActionIcon onClick={handleApply} color='green'>
                    <IconCheck style={{ width: '90%', height: '90%' }} stroke={2} />
                  </ActionIcon>
                </Group>
              </Stack>
            </Popover.Dropdown>
          </Popover>
        { textValue &&
        <Pill
          defaultChecked={true}
          size='xl'
          c='blue'
          withRemoveButton
          onRemove={() => onRemove(term, selectedFilters[term])}
          maw={300}
          style={{ textOverflow: 'ellipsis' }}
        >
          {selectedFilters[term]}
        </Pill>
        }
      </>
  )
}
